import { render, staticRenderFns } from "./lottery-list.vue?vue&type=template&id=afdffd44&"
import script from "./lottery-list.vue?vue&type=script&lang=js&"
export * from "./lottery-list.vue?vue&type=script&lang=js&"
import style0 from "./lottery-list.vue?vue&type=style&index=0&id=afdffd44&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports